export default "__VITE_ASSET__3e665948__"